import { useNavigation } from 'expo-router';
import { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';

import GoBackButton from '@/components/buttons/GoBackButton';
import DownloadTransactionsButton from '@/components/buttons/DownloadTransactionsButton';
import TransactionsList from '@/components/paymentMethods/TransactionsList';
import Title from '@/components/Title';
import { i18n } from '@/utils/i18n';

const Transactions = () => {
  const navigation = useNavigation();

  //Locales
  const title = i18n.t('settings.screen_names.transactions');

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <Title label={title} />,
      headerLeft: () => <GoBackButton />,
      headerRight: () => <DownloadTransactionsButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  return (
    <View style={styles.flexOne}>
      <TransactionsList amountColor="red" isNpo={false} />
    </View>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  }
});

export default Transactions;
